<div *ngIf="trial">

  <div class="item" (click)="onSelectTop()">
    ClinicalTrials.gov
  </div>

  <div class="item" (click)="onSelectCohort(null)">
    Cohorts
  </div>

  <div  *ngIf="trial.profile">
    <div class="item subItem" *ngFor="let cohort of trial.profile.cohorts" (click)="onSelectCohort(cohort)">
      {{cohort.name}}
    </div>
  </div>

</div>
